import { CommonModule, ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';

import { StorageService } from 'src/app/core/storage/storage.service';

import { Campaign, Stock } from 'src/app/shared/model/campaign.model';
import { OptionsCardComponent } from './options-card/options-card.component';
import { OrderService } from 'src/app/core/services/order.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-campaign-detail',
  templateUrl: './campaign-detail.component.html',
  styleUrls: ['./campaign-detail.component.scss'],
  imports: [
    CommonModule,
    OptionsCardComponent,
    MatButtonModule,
    I18NextModule,
    RouterModule
  ]
})
export class CampaignDetailComponent implements OnInit, AfterViewInit {
  campaignVehicle?: Campaign;
  campaignList?: any;

  constructor(
    private storageService: StorageService,
    private orderService: OrderService,
    private navigationService: NavigationService,
    private scroller: ViewportScroller,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('');
    }, 0);
  }

  ngOnInit(): void {
    this.campaignVehicle = this.storageService.get('stock');

    this.orderService.getCampaignsList().subscribe({
      next: (resp) => {
        this.campaignList = resp;
        this.campaignList = this.campaignList.filter((campaign: Campaign) => {
          return campaign.id !== this.campaignVehicle?.id;
        });
      }
    });
  }

  updateSelectedVehicle(vehicle: Stock) {
    this.storageService.removeItem('stock');
    this.storageService.set('stock', vehicle);
    this.router.navigateByUrl('/campaign');
  }

  scrollDown(target: string) {
    this.scroller.scrollToAnchor(target);
  }

  selectCampaign(campaign: Campaign) {
    this.storageService.removeItem('stock');
    this.storageService.set('stock', campaign);
    window.location.reload();
  }
}
